// extracted by mini-css-extract-plugin
export default {"container":"GM-z","topReviewHeading":"HM-z","criticalReview":"IM-z","favorableReview":"JM-z","vsSeparator":"KM-z"};